export interface ForeignKeyConstraint {
    referenceTable: string
    referenceKey: string
}

export interface SQLiteTable {
    name: string
    type: string
    isPrimary?: boolean
    defaultValue?: string | number | null
    foreignKey?: ForeignKeyConstraint
}

export const SyncOfflineData: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'data', type: 'text'},
    {name: 'images', type: 'text', defaultValue: null},
    {name: 'userId', type: 'integer'},
    {name: 'typeOfData', type: 'text'},
    {name: 'createdAt', type: 'text', defaultValue: null},
]

export const Documents: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'documentId', type: 'text'},
    {name: 'parentId', type: 'text'},
    {name: 'machineId', type: 'text'},
    {name: 'data', type: 'text'},
    {name: 'downloadLink', type: 'text', defaultValue: null},
    {name: 'filePath', type: 'text', defaultValue: null},
];

export const Project: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'name', type: 'text'},
    {name: 'number', type: 'text'},
    {name: 'image', type: 'text', defaultValue: null},
    {name: 'isFavorite', type: 'boolean', defaultValue: 0},
    {name: 'isLastUsed', type: 'boolean', defaultValue: 0},
]

export const Machine: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'data', type: 'text'},
    {name: 'categoryImage', type: 'text', defaultValue: null},
];

export const Users: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'name', type: 'text'},
];

export const IssueCategories: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'name', type: 'text'},
];

export const Departments: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'name', type: 'text'},
];

export const Issue: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'machineId', type: 'integer'},
    {name: 'data', type: 'text'},
    {name: 'images', type: 'text', defaultValue: null},
];

export const MachineSpecification: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'hovedNo', type: 'text', defaultValue: null},
    {name: 'data', type: 'text'},
];

export const IssueSortingTypes: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'name', type: 'text'},
];

export const IssueLabels: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'name', type: 'text'},
    {name: 'colorName', type: 'text'},
];

export const Service: SQLiteTable[] = [
    {name: 'id', type: 'integer', isPrimary: true},
    {name: 'machineId', type: 'integer'},
    {name: 'data', type: 'text'},
];

export const Schemas = {
    SyncOfflineData,
    Documents,
    Project,
    Machine,
    Users,
    IssueCategories,
    Departments,
    Issue,
    MachineSpecification,
    IssueSortingTypes,
    IssueLabels,
    Service,
};
